import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	container: {
		display      : "grid",
		placeContent : "center",
		height       : "50vh",
		textAlign    : "center"
	},
	icon: {
		height : "20rem",
		width  : "20rem"
	}
} ), { name: "emptyFeed" } );

